import React from 'react';
import { Link } from 'react-router-dom';
import StatusBadge from './StatusBadge';
import { ArrowRight, Package } from 'lucide-react';

export default function ShipmentCard({ shipment }) {
  return (
    <Link
      to={`/shipments/${shipment.id}`}
      className="group block rounded-xl border border-white/10 bg-navy-900 p-6 hover:-translate-y-0.5 hover:border-white/20 transition-all"
      data-testid={`shipment-card-${shipment.reference}`}
    >
      <div className="flex items-start justify-between gap-4 mb-4">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono">{shipment.reference}</div>
          <div className="font-display font-semibold text-white text-lg mt-1 truncate">{shipment.product_name}</div>
          <div className="text-sm text-slate-400 mt-1 flex items-center gap-1.5">
            <span>{shipment.origin_country}</span>
            <ArrowRight className="h-3 w-3" />
            <span>{shipment.destination_country}</span>
            <span className="text-slate-600 mx-1">·</span>
            <span className="text-slate-500">{shipment.mode}</span>
          </div>
        </div>
        <div className="h-10 w-10 rounded-lg bg-cyan-glow/10 border border-cyan-glow/20 grid place-items-center text-cyan-glow shrink-0">
          <Package className="h-5 w-5" />
        </div>
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-white/5">
        <StatusBadge status={shipment.status} />
        <div className="text-xs text-slate-500 font-mono">
          {shipment.open_issues_count > 0
            ? `${shipment.open_issues_count} open issue${shipment.open_issues_count === 1 ? '' : 's'}`
            : 'No open issues'}
        </div>
      </div>
    </Link>
  );
}
